import { Modal, Typography, Button } from 'antd';

export function QboImportHelpModal({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Importing into QuickBooks Online"
      footer={<Button onClick={onClose}>Close</Button>}
    >
      <Typography.Paragraph>
        After you click <strong>Export</strong>, your <code>.qbo</code> file
        will appear in <strong>Data Exports</strong>. Once it's ready:
      </Typography.Paragraph>
      <ol style={{ paddingLeft: 20 }}>
        <li>
          Download the <code>.qbo</code> file from TACH.
        </li>
        <li>
          In QuickBooks Online, go to{' '}
          <strong>Banking &rarr; Link account &rarr; Upload from file</strong>.
        </li>
        <li>
          Choose the <code>.qbo</code> file you downloaded from TACH.
        </li>
        <li>
          Pick (or create) the account in your QuickBooks chart of accounts that
          this maps to.
        </li>
        <li>
          QuickBooks will categorize the transactions; you can recategorize as
          needed.
        </li>
        <li>
          On future imports, QuickBooks automatically deduplicates by
          transaction ID.
        </li>
      </ol>
      <Typography.Paragraph type="secondary" style={{ marginTop: 16 }}>
        Need help? Contact support.
      </Typography.Paragraph>
    </Modal>
  );
}
